@use 'button-group-common';

:host {
  @include button-group-common.wb-button-group;
}

:host([direction='horizontal']) {
  @include button-group-common.wb-button-group-horizontal;
}

:host([direction='vertical']) {
  @include button-group-common.wb-button-group-vertical;
}

::slotted(.wb-popover) {
  @include button-group-common.wb-button-group-popover;
}
